// extracted by mini-css-extract-plugin
export default {"headerImage":"Vx5Ns","headerTitle":"m345D"};